export default __webpack_public_path__ + "static/media/step1.273a5dbe.png";